export async function decodeAudioRecordingBlobToAudioBuffer({
  blob,
  audioContext,
}: {
  blob: Blob;
  audioContext: AudioContext;
}): Promise<AudioBuffer> {
  const arrayBuffer = await blob.arrayBuffer();
  return new Promise((resolve, reject) => {
    audioContext.decodeAudioData(arrayBuffer.slice(0), resolve, reject);
  });
}

export async function resampleAudioRecordingBufferToMono({
  buffer,
  targetSampleRate,
}: {
  buffer: AudioBuffer;
  targetSampleRate: number;
}): Promise<AudioBuffer> {
  const frames = Math.max(1, Math.ceil(buffer.duration * targetSampleRate));
  const offlineContext = new OfflineAudioContext(1, frames, targetSampleRate);

  const source = offlineContext.createBufferSource();
  source.buffer = buffer;
  source.channelCount = 1;
  source.channelCountMode = "explicit";
  source.channelInterpretation = "speakers";
  source.connect(offlineContext.destination);
  source.start(0);

  return offlineContext.startRendering();
}

export function convertAudioRecordingFloat32ToPcm16({
  samples,
}: {
  samples: Float32Array;
}): Int16Array {
  const output = new Int16Array(samples.length);
  for (let i = 0; i < samples.length; i += 1) {
    const sample = Math.max(-1, Math.min(1, samples[i]));
    output[i] = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
  }
  return output;
}

export function encodeAudioRecordingPcm16ToBase64({ samples }: { samples: Int16Array }): string {
  const view = new Uint8Array(samples.buffer, samples.byteOffset, samples.byteLength);
  let binary = "";
  for (let i = 0; i < view.length; i += 1) {
    binary += String.fromCharCode(view[i]);
  }
  return btoa(binary);
}
